import * as am5 from '@amcharts/amcharts5';

export const applyClickView = (
  obj: any,
  mainChart: any,
  selectedCountryPolygon: any,
  handleSelectCountry: any,
) => {
  obj.mapPolygons.template.on('active', (active: any, target: any) => {
    if (active) {
      handleSelectCountry(target.dataItem.dataContext.id);
    } else {
      handleSelectCountry(null);
      return;
    }

    if (selectedCountryPolygon && selectedCountryPolygon !== target) {
      selectedCountryPolygon.set('active', false);
    }

    if (target.get('active')) {
      const centroid = target.geoCentroid();

      if (centroid) {
        mainChart.animate({
          key: 'rotationX',
          to: -centroid.longitude,
          duration: 1500,
          easing: am5.ease.inOut(am5.ease.cubic),
        });

        mainChart.animate({
          key: 'rotationY',
          to: -centroid.latitude,
          duration: 1500,
          easing: am5.ease.inOut(am5.ease.cubic),
        });
      }
    }
    selectedCountryPolygon = target;
  });
};
